import * as decode from 'jwt-decode';

import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  listing_id: any;
  user_id: any;
  address: any;
  showNav: boolean = false;
  route: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {}

  public saveToken(token: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('access_u_token', token);
    }
  }
  public saveRedirectUrl(redirect_url: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('redirect_url', redirect_url);
    }
  }
  public saveTwilioToken(token: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('twilio_u_token', token);
    }
  }
  public saveSignatureBlob(img_blob) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('sig_blob', img_blob);
    }
  }

  saveSearchToLocalStorage(search) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('u_search', search);
    }
  }

  getSearchFromLocalStorage() {
    if (isPlatformBrowser(this.platformId)) {
      const stringified_search = localStorage.getItem('u_search');
      if (stringified_search) {
        return JSON.parse(stringified_search);
      } else {
        return null;
      }
    }
  }

  saveLatLngToLocalStorage(lat_lng) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('lat_lng', lat_lng);
    }
  }

  getLatLngFromLocalStorage() {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem('lat_lng'));
    } else {
      return {};
    }
  }
  removeLatLngFromLocalStorage() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('lat_lng');
    }
  }

  public getAccessTokenId() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('access_u_token');
    }
  }
  public getTwilioAccessTokenId() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('twilio_u_token');
    }
  }
  public getSignatureBlob() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('sig_blob');
    }
  }
  public getAccessTokenInfo() {
    if (isPlatformBrowser(this.platformId)) {
      const access_token = localStorage.getItem('access_u_token');
      const { payload } = decode(access_token);
      if (payload && payload.first_name) {
        return payload;
      } else {
        return { first_name: '', role: '', last_name: '' };
      }
    }
 }

  public decodeToken(token: string) {
    const { payload } = decode(token);
    return payload;
  }
  public decodeTokenType(token: string) {
    const { type } = decode(token);
    return type;
  }

  /**
   * Clear token and other user releated data.
   */

  public clearToken() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('access_u_token');
      localStorage.removeItem('twilio_u_token');
      // localStorage.removeItem('user_id')
    }
  }
  public clearTwilioToken() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('twilio_u_token');
    }
  }
  public logout(returnUrl?) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('access_u_token');
      localStorage.removeItem('twilio_u_token');
      // localStorage.removeItem('user_id')
      if (returnUrl) {
        // console.log('return url: ',returnUrl)
        this.router.navigate([`${returnUrl}`]);
      } else {
        // this.router.navigate(['/login']);
        this.router.navigate(['/login']);
      }
    }
  }
  public setRoute(route) {
    this.route = route;
  }
  public getRoute() {
    return this.route;
  }
  public setListingDetails(listing_id: any, address: any, user_id: any) {
    this.listing_id = listing_id;
    this.address = address;
    this.user_id = user_id;
  }
  public getListingDetails(): any {
    let data = {
      listing_id: this.listing_id,
      address: this.address,
      user_id: this.user_id,
    }
    return data;
  }

  public getWebToken() {
    return this.getAccessTokenId();
  }

  public replaceToken(token:string) {
    localStorage.setItem('access_u_token', token);
  }
}